'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipContainer = undefined;
var _templateObject = _taggedTemplateLiteral(['\n  ', ';\n  & > .tooltip-inner{\n    width: 32rem;\n    max-width: 32rem;\n    height: 4rem !important;\n    max-height: 4rem !important;\n    z-index: 9999;\n    border-radius: 0;\n    padding: .1rem .4rem;\n    left: 0;\n    top: 1.2rem;\n    font-size: .85rem !important;\n    font-family: \'Open Sans\' !important;\n    left: 2rem;\n    line-height: 1rem;\n    box-shadow: 0px 0px 15px 0px ', ';\n    border-color: transparent;\n    background-color: ', ';\n    color: ', ';\n    ', ';\n  }\n\n  & > .arrow {\n    &::before {\n      ', ';\n    }\n  }\n'], ['\n  ', ';\n  & > .tooltip-inner{\n    width: 32rem;\n    max-width: 32rem;\n    height: 4rem !important;\n    max-height: 4rem !important;\n    z-index: 9999;\n    border-radius: 0;\n    padding: .1rem .4rem;\n    left: 0;\n    top: 1.2rem;\n    font-size: .85rem !important;\n    font-family: \'Open Sans\' !important;\n    left: 2rem;\n    line-height: 1rem;\n    box-shadow: 0px 0px 15px 0px ', ';\n    border-color: transparent;\n    background-color: ', ';\n    color: ', ';\n    ', ';\n  }\n\n  & > .arrow {\n    &::before {\n      ', ';\n    }\n  }\n']),
  _templateObject2 = _taggedTemplateLiteral(['', ''], ['', '']),
  _templateObject3 = _taggedTemplateLiteral(['', ': ', ''], ['', ': ', '']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _reactstrap = require('reactstrap');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var TooltipContainer = exports.TooltipContainer = (0, _styledComponents2.default)(_reactstrap.Tooltip)(_templateObject, function (props) {
  return props.customstyle;
}, function (props) {
  return props.theme['color_gray-X11-gray'];
}, function (props) {
  return props.theme.color_white;
}, function (props) {
  return props.theme.color_gray;
}, function (props) {
  return (0, _styledComponents.css)(_templateObject2, props.innerstyle);
}, function (props) {
  return (0, _styledComponents.css)(_templateObject3, props.borderRule, props.theme.color_white);
});